import { Button, Layout } from 'antd';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import DashboardImg from '../../Assets/b2b2c_dashboard_img.png';

import React from 'react';
import { HeaderB2B2C } from './Components/HeaderB2B2C';
import ContentB2B2C from './Components/Content';
// import {SRLogo} from 'src/Assets/Icons/SRLogo.png';
import Logo from '../../Assets/Icons/SRLogo.png';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const layoutStyle = {
  borderRadius: 8,
  //   overflow: 'hidden',
  //   width: 'calc(50% - 8px)',
  //   maxWidth: 'calc(50% - 8px)',
  height: '60px',
};

const contentStyle = {
  textAlign: 'center',
  //   minHeight: 120,
  lineHeight: '120px',
  color: 'red',
  backgroundColor: '#0958d9',
};

const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#4096ff',
};

const WelcomeB2B2C = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  // const planId = query.get('plan');
  const referralCode = decodeURIComponent(query.get("referral_code"));
  const userEmail = decodeURIComponent(query.get("email"));

  console.log("referral code fetcing", userEmail)

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        fontFamily: 'Montserrat',
      }}
    >
      <Layout style={layoutStyle}>
        <HeaderB2B2C />
        <ContentB2B2C referralCode={referralCode} userEmail={userEmail}/>
        

        {/* <div>hiii</div> */}
        <Footer style={{
          backgroundColor:'#472567',
          height:'140px',
          display:'flex',
          flexDirection:'row',
          gap:'20px',
          justifyContent:'space-between',
          alignItems:'center',
          padding:'0px 80px',
          borderTop: '1px solid #fff',
        }}>
          <img src={Logo} height={38.43041229248047} width={212.70968627929688} style={{
            marginTop:'40px',
            marginBottom:'40px',
          }}/>

          <div style={{
            display:'flex',
            flexDirection:'row',
            gap:'40px',
            color:'#fff',
            fontFamily:'Montserrat',
            fontSize:'16px',
            fontWeight:500,
          }}>
            <div>{`(077) 092 33 53`}</div>
            <div>Contact us</div>
            <div>Emergency resources</div>
            <div>Privacy policy</div>
            <div>Terms and condition</div>
          </div>
        </Footer>
      </Layout>
    </div>
  );
};

export default WelcomeB2B2C;
